module.exports = __webpack_public_path__ + "static/media/logo192.ae628f6e.png";